import { Injectable } from '@angular/core'

import { Observable } from 'rxjs/Observable'

import { LectureApiBase } from './lecture-api'
import { User } from '../models/user'

@Injectable()
export class UserApi {
  private apiPath = 'profile'

  constructor(
    private api: LectureApiBase,
  ) {}

  profile(): Observable<User> {
    return this.api.getWithObject(User, `${this.apiPath}`)
  }
}



// WEBPACK FOOTER //
// ./src/apis/user.ts